import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

type Props = {
  children: ReactNode
  className?: string
}

export function IconButtonGroup({ children, className }: Props) {
  return (
    <div
      className={cn(
        "inline-flex h-8 items-stretch divide-x divide-ui-border-strong overflow-hidden rounded-lg border border-ui-border-strong",
        className,
      )}
    >
      {children}
    </div>
  )
}
